import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ApproachSection from './components/ApproachSection';
import ValuesSection from './components/ValuesSection';
import FooterSection from './components/FooterSection';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <main>
      <Navbar scrolled={scrolled} />
      <HeroSection />
      <ServicesSection />
      <ApproachSection />
      <ValuesSection />
      <FooterSection />
    </main>
  );
}